import React from 'react';
import { Link } from 'react-router-dom';
import { Send, Loader2, Check } from 'lucide-react';
import { IconBrandFacebook, IconBrandInstagram, IconBrandGithub, IconBrandLinkedin } from '@tabler/icons-react';
import { W } from './Shared';

const Footer = ({ nl, setNl, nlSt, submitNL }) => {
  return (
    <footer style={{ background: 'var(--on-surface)', paddingTop: 120, paddingBottom: 60 }}>
      <W>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 64, marginBottom: 80 }} className="footer-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
              <img src="/ICDITC%20Icon%201.png" alt="ICDITC" style={{ height: 60 }} />
              {/* <span style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, color: '#fff', letterSpacing: '-0.02em' }}>ICDITC</span> */}
            </div>
            <p style={{ color: 'rgba(255,255,255,.7)', fontSize: 15, lineHeight: 1.7, maxWidth: 300, marginBottom: 32 }}>
              A student-driven space to learn, explore and grow through technology.
            </p>
            <div style={{ display: 'flex', gap: 16 }}>
              {[
                { icon: <IconBrandInstagram size={20} />, link: 'https://www.instagram.com/icditc' },
                { icon: <IconBrandFacebook size={20} />, link: 'https://www.facebook.com/icditc' },
                { icon: <IconBrandLinkedin size={20} />, link: 'https://linkedin.com/in/icditc' },
                { icon: <IconBrandGithub size={20} />, link: 'https://github.com/icditc' }
              ].map((s, i) => (
                <a key={i} href={s.link} target="_blank" rel="noreferrer" style={{ width: 44, height: 44, borderRadius: 10, background: 'rgba(255,255,255,.05)', color: 'rgba(255,255,255,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .3s', border: 'none' }} onMouseOver={e => { e.currentTarget.style.color = 'var(--primary)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.background = 'rgba(255,255,255,.1)'; }} onMouseOut={e => { e.currentTarget.style.color = 'rgba(255,255,255,.5)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.background = 'rgba(255,255,255,.05)'; }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#fff', marginBottom: 24 }}>Navigation</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { to: '/', label: 'Home' },
                { to: '/our-story', label: 'About' },
                { to: '/knowledge-hub', label: 'Knowledge Hub' },
                { to: '/committee', label: 'Committee' },
                { to: '/membership', label: 'Join Club' },
                { href: 'https://membership.icditc.club/', label: 'Membership Portal' }
              ].map(l => l.href ? (
                <a key={l.href} href={l.href} target="_blank" rel="noreferrer" style={{ color: 'rgba(255,255,255,.5)', fontSize: 14, textDecoration: 'none', transition: 'color .2s' }} onMouseOver={e => e.target.style.color = 'var(--primary)'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l.label}</a>
              ) : (
                <Link key={l.to} to={l.to} style={{ color: 'rgba(255,255,255,.5)', fontSize: 14, textDecoration: 'none', transition: 'color .2s' }} onMouseOver={e => e.target.style.color = 'var(--primary)'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l.label}</Link>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#fff', marginBottom: 24 }}>Legal & Info</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { to: '/events', label: 'Events' },
                { to: '/privacy-policy', label: 'Privacy Policy' },
                { to: '/membership-policy', label: 'Membership Policies' },
                { to: '/verify', label: 'Verify Certificate (Beta)' }
              ].map(l => <Link key={l.to} to={l.to} style={{ color: 'rgba(255,255,255,.5)', fontSize: 14, textDecoration: 'none', transition: 'color .2s' }} onMouseOver={e => e.target.style.color = 'var(--primary)'} onMouseOut={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l.label}</Link>)}
            </div>
          </div>

          <div>
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.2em', color: '#fff', marginBottom: 24 }}>Newsletter Update</h4>
            <p style={{ color: 'rgba(255,255,255,.5)', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>Stay updated with learning resources, events and opportunities.</p>
            <form onSubmit={submitNL} style={{ position: 'relative' }}>
              <input type="email" value={nl} onChange={e => setNl(e.target.value)} placeholder="Email address" style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', padding: '16px 20px', borderRadius: 8, color: '#fff', outline: 'none', fontSize: 14 }} disabled={nlSt !== 'idle'} required />
              <button type="submit" disabled={nlSt !== 'idle'} style={{ position: 'absolute', right: 8, top: 8, bottom: 8, width: 40, borderRadius: 6, background: 'var(--primary)', color: '#fff', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {nlSt === 'loading' ? <Loader2 size={16} className="spin" /> : nlSt === 'success' ? <Check size={16} /> : <Send size={16} />}
              </button>
            </form>
          </div>
        </div>

        <div style={{ paddingTop: 40, borderTop: '1px solid rgba(255,255,255,.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 20 }}>
          <p style={{ color: 'rgba(255,255,255,.4)', fontSize: 13 }}>&copy; {new Date().getFullYear()} ICDITC. All rights reserved.</p>
        </div>
      </W>
    </footer>
  );
};

export default Footer;
